import React, { useEffect, useState } from 'react';
import { pushSupported, isPushEnabled, enablePush } from '../services/push';

/** 通知（プッシュ）を有効化する小さなベルボタン。未購読のときだけ表示する。
 *  緊急連絡・お知らせ・承認結果を、アプリを開いていなくても端末通知で受け取れる。 */
export const PushBell: React.FC = () => {
  const [supported] = useState(pushSupported());
  const [enabled, setEnabled] = useState(true); // 判定前は非表示（trueで隠す）
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!supported) return;
    isPushEnabled().then(setEnabled).catch(() => setEnabled(false));
  }, [supported]);

  if (!supported || enabled) return null;

  const onClick = async () => {
    setBusy(true); setMsg(null);
    const r = await enablePush();
    setBusy(false);
    if (r.ok) { setEnabled(true); }
    else { setMsg(r.reason ?? '有効化できませんでした'); setTimeout(() => setMsg(null), 5000); }
  };

  return (
    <>
      <button onClick={onClick} disabled={busy}
        title="緊急連絡・承認結果をスマホ通知で受け取る"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          background: '#fff7ed', border: '1px solid #fed7aa', color: '#c2410c',
          borderRadius: 999, padding: '4px 11px', fontSize: 11, fontWeight: 700, cursor: 'pointer',
        }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
        {busy ? '設定中…' : '通知をON'}
      </button>
      {msg && (
        <div style={{ position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: '#dc2626', color: '#fff', padding: '10px 18px', borderRadius: 20, fontSize: 12, fontWeight: 700, maxWidth: 320, textAlign: 'center' }}>{msg}</div>
      )}
    </>
  );
};
